import Alpine from 'alpinejs'

export default function ambassadors(el) {
    const wrapperElement = el.querySelector('.ambassadors .items-wrapper')
    let lerpVal = 0.1
    Alpine.store('ambassadors', {
        translateX: 0,
        lerpTranslate: 0,
        isDragging: false,
        lastX: 0,
        selectedIndex: null,
        onDragStart() {
            lerpVal = 0.5
            this.lastX = this.translateX
            this.isDragging = true
        },
        onWheel(e) {
            if (e.deltaX) {
                lerpVal = 1
                this.translateX -= e.deltaX
                this.onDragEnd()
            }
        },
        onDrag(e) {
            this.translateX = this.lastX + e.deltaX
        },
        onDragEnd() {
            setTimeout(() => this.isDragging = false, 0)
            lerpVal = 0.1
            this.lastX = this.translateX
            if (this.translateX > 0) {
                this.translateX = 0
                return
            }
            const rect = wrapperElement.getBoundingClientRect()
            const diff = this.translateX + rect.width - window.innerWidth
            if (diff < 0) {
                this.translateX -= diff
            }
        },
        onClickEl(index) {
            if (!this.isDragging) {
                this.selectedIndex = index === this.selectedIndex ? null : index
            }
        },
        prev() {
            this.translateX = Math.min(
                this.translateX + 250,
                0
            )
        },
        next() {
            this.translateX = Math.max(
                this.translateX - 250,
                -wrapperElement.getBoundingClientRect().width + window.innerWidth
            )
        }
    })
    const ambassadorsStore = Alpine.store('ambassadors')
    const hammerEl = new Hammer(wrapperElement)
    hammerEl.on('panstart', () => ambassadorsStore.onDragStart())
    hammerEl.on('panend', (e) => ambassadorsStore.onDragEnd(e))
    hammerEl.on('pan', (e) => ambassadorsStore.onDrag(e))
    console.log(hammerEl)
    const updateLerp = () => {
        let realTranslate = ambassadorsStore.translateX
        const rect = wrapperElement.getBoundingClientRect()
        let diff = realTranslate + rect.width - window.innerWidth
        if (diff < 0) {
            realTranslate -= diff
            diff /= 4
            realTranslate += diff
        }
        if (realTranslate > 0) realTranslate /= 4
        ambassadorsStore.lerpTranslate += (realTranslate - ambassadorsStore.lerpTranslate) * lerpVal
        window.requestAnimationFrame(updateLerp)
    }
    updateLerp()
}
